import { useState, useEffect, useRef } from 'react';
import { ORDER_MANAGEMENT_CONSTANTS } from '../constants/orderManagement';

export const useResizeHandle = (initialWidth: string = ORDER_MANAGEMENT_CONSTANTS.DEFAULT_SIDEBAR_WIDTH) => {
  const [sidebarWidth, setSidebarWidth] = useState<string>(initialWidth);
  const [isResizing, setIsResizing] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!isResizing || !containerRef.current) return;

      const containerRect = containerRef.current.getBoundingClientRect();
      const newWidth = e.clientX - containerRect.left;
      const minWidth = ORDER_MANAGEMENT_CONSTANTS.SIDEBAR_MIN_WIDTH;
      const maxWidth = containerRect.width * ORDER_MANAGEMENT_CONSTANTS.SIDEBAR_MAX_WIDTH_RATIO;

      if (newWidth >= minWidth && newWidth <= maxWidth) {
        setSidebarWidth(`${newWidth}px`);
      }
    };

    const handleMouseUp = () => {
      setIsResizing(false);
    };

    if (isResizing) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isResizing]);

  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsResizing(true);
  };

  return {
    sidebarWidth,
    isResizing,
    containerRef,
    handleMouseDown,
  };
};